<template>
  <div class="site-view">
    <section class="site-text">
      <div class="container about-section">
        <div class="text">
          <h2>Background</h2>
          <p>
            The B4063 Gloucester to Cheltenham Cycleway started as a Highways
            England project with the strategic aim to link the major areas of
            Gloucester, Cheltenham and the villages in between.
          </p>
          <p>
            A series of ring-fenced funds have been put aside by Highways
            England to invest in cycle infrastructure. A study was done in
            2015/16 to assess the most continuous, direct, comfortable, safe and
            attractive route for cyclists of all abilities. The B4063 was
            selected as the preferred route as it’s near the A40 strategic
            corridor but is much safer than cycling on the A40 itself. The A40
            is not suitable for a cycle route due to high speeds and the
            motorway junction.
          </p>
          <p>
            Highways England and their term consultant Kier completed
            preliminary design which has been passed to Gloucestershire County
            Council and their design team at Atkins for further development.
            Your feedback will help the team to finalise these designs and move
            the project forward.
          </p>
        </div>
        <div class="image">
          <div
            :style="{
              'background-image': `url(${require('@/assets/images/CycleRoute/About-01_Background.jpg')})`,
            }"
          ></div>
        </div>
      </div>
      <div
        class="container about-section"
        style="padding-bottom: 20px !important"
      >
        <div class="image">
          <div
            :style="{
              'background-image': `url(${require('@/assets/images/CycleRoute/About-02_ExistingCycleRoute.jpg')})`,
            }"
          ></div>
        </div>
        <div class="text right">
          <h2>Existing cycle access</h2>
          <p>
            Cycle facilities currently provided along the B4063 from Elmbridge
            Court Roundabout to Arle Court are made up of a mixture of on road
            cycle lanes and off-road paths, sharing the pavement with
            pedestrians. In places there is no dedicated cycle facility at all.
            The speed limits vary between 30mph and 50 mph towards the
            Cheltenham end of the route. Latest design standards provide
            guidance and good practice for the design of cycle infrastructure.
            Cyclists should not share the space used by pedestrians and a
            physically segregated track from pedestrians and motorists is
            required in urban areas
          </p>
        </div>
      </div>

      <div class="about-section divide">
        <div class="divide-image">
          <div
            :style="{
              'background-image': `url(${require('@/assets/images/CycleRoute/GCC_Fullwidth_Home_Banner.jpg')})`,
            }"
          ></div>
        </div>
      </div>

      <div class="container about-section">
        <div class="text">
          <h2>Aims of the scheme</h2>
          <p>
            The B4063 Cycleway will run between Gloucester and Cheltenham. A
            continuous cycleway along this route will:
          </p>
          <ul>
            <li>Help cyclists of all ages and abilities to travel safely.</li>
            <li>
              Improve health and wellbeing in the community while reducing
              Gloucestershire’s carbon emissions.
            </li>
            <li>
              Give a continuous route for cyclists and make cycling and
              sustainable travel more appealing; helping to get people out of
              their cars, cutting congestion in the area.
            </li>
            <li>
              Improve bus times - if there’s less traffic around, buses are more
              likely to be on time.
            </li>
            <li>
              Connect other cycle routes together, like London Road in
              Gloucester and the A40 in Cheltenham.
            </li>
            <li>
              Help people to reboot their commute by linking residents, schools
              and businesses in Churchdown, Innsworth and Staverton to public
              transport hubs in both Gloucester and Cheltenham.
            </li>
            <li>Assist the local recovery from the COVID-19 pandemic.</li>
          </ul>
        </div>
        <div class="image">
          <div
            :style="{
              'background-image': `url(${require('@/assets/images/CycleRoute/GCC_About-ProposedAims.jpg')})`,
            }"
          ></div>
        </div>
      </div>
      <div class="about-cards-section">
        <div class="container">
          <div>
            <h2>Active travel, climate change and looking to the future</h2>
            <p>
              Gloucestershire has committed to becoming a carbon neutral county
              by 2045. About a third of the County’s carbon emissions come from
              transport like cars, buses, trains and lorries. One way we can all
              help to tackle climate change, lower our carbon emissions and
              improve air quality is to encourage active travel like walking and
              cycling.
            </p>
          </div>
          <div class="card-container">
            <div class="card-content">
              <p>
                In 2020 the County Council was given Government funding to
                invest in projects like cycle lanes in response to the COVID-19
                pandemic. The number of seats available on public transport has
                become limited due to social distancing and passengers needing
                more space. Some shorter journeys could be made by bike instead.
                By investing in cycle facilities and providing better quality
                routes cycling will become a more attractive option, allowing
                those who had no alternative a safer journey on public
                transport. Some of this funding was put into the London Road
                cycle lanes in Gloucester, which will connect to the B4063 route
                when the scheme is complete.
              </p>
            </div>
            <div class="card-content">
              <p>
                At the Cheltenham end of the route, work has started on building
                the cycling facilities which will connect the B4063 to the A40,
                Cheltenham Rail Station and Cheltenham town center. The West
                Cheltenham Transport Improvement Scheme will be complete in
                2022. Work is also planned for the Arle Court Park and Ride
                site, set to transform it into a Transport Hub. The improvements
                will have a real focus on sustainable transport and providing
                high quality alternatives to car use, with the B4063 cycle
                scheme linking up to create a cohesive network.
              </p>
            </div>
            <div class="card-content">
              <p>
                Once complete, the cycle network in Gloucestershire will provide
                a continuous facility 26 miles long spanning a large part of the
                Severn Vale. There will be a cycle route running from Stroud to
                Saul along the canal towpath towards Gloucester and seamlessly
                through to the north of Cheltenham, giving sustainable travel
                options for future generations.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="site-bannerbox"
        :style="{
          backgroundImage: `url(${backgroundUrl2})`,
        }"
      >
        <div class="container">
          <div class="row">
            <div class="col s12 m12 l6">
              <div class="box">
                <h2>How to have your say</h2>
                <p>
                  Take some time to explore our
                  <router-link to="/site/furtherInfoPage">proposals</router-link
                  >, then provide your feedback using our
                  <router-link to="/site/FeedbackSurvey">survey</router-link>.
                </p>
                <router-link to="/site/FeedbackSurvey" class="banner-btn"
                  >Open Survey</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="container" />
    </section>

    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from "@/components/customPages/components/footer.vue";
import { mapState, mapGetters } from "vuex";
import backgroundUrl2 from "@/assets/images/template/home/questionnaire.jpg";

export default {
  name: "About",
  data() {
    return {
      fundIcon: require("@/assets/images/CycleRoute/IconFunds.svg"),
      buildIcon: require("@/assets/images/CycleRoute/IconBuild.svg"),
      routeIcon: require("@/assets/images/CycleRoute/IconRoute.svg"),
      backgroundUrl2: backgroundUrl2,
    };
  },
  components: {
    SiteFooter,
  },
};
</script>

<style lang="scss" scoped>
.site-text {
  hr {
    background-color: #1e3556;
    height: 3px;
    border: none;
  }
}

.about-section {
  padding: 30px 0 150px;
  display: flex;
  flex-direction: row;

  &.divide {
    padding-bottom: 70px !important;
  }

  .divide-image {
    width: 100%;
    justify-content: center;
    height: 600px;

    div {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
    }
  }

  .text {
    width: 50%;
    padding: 0 20px;
    margin: auto 0;

    h2 {
      font-size: 40px;
    }

    ul {
      margin-left: 20px;

      padding-right: 20px;
      font-size: 16px;

      li {
        list-style-type: disc;
        margin-bottom: 10px;
      }
    }

    .quote {
      border-left: 8px solid #0055a5;
      margin-top: 30px;
      padding-left: 25px;
      color: #0055a5;
      font-size: 25px;
      font-weight: bold;
    }
  }

  .image {
    width: 50%;
    justify-content: center;
    padding: 0 20px;
    height: 450px;

    div {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
    }
  }

  .image-large {
    height: 700px;
    width: 50%;
    justify-content: center;
    padding: 0 20px;
    position: relative;

    div {
      width: 100%;
      height: 100%;
      background-size: cover;
    }
  }
}

.about-cards-section {
  background-color: #0055a5;
  padding: 100px 0;
  margin: 0 0 100px;

  h2 {
    font-size: 40px;
  }

  h2,
  div,
  p {
    color: white !important;
  }

  .card-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 80px;

    .card-content {
      width: 31%;
      border: solid 2px white;
      padding: 32px;
      min-height: 450px;

      div {
        height: 100px;
        width: 100px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      h3 {
        font-size: 32px;
        font-family: museo-slab, serif;
        font-weight: 700;
        margin: 20px 0;
      }

      &:hover {
        background: white;
        svg {
          path {
            stroke: #0055a5;
            fill: #0055a5;
          }
          line {
            stroke: #0055a5;
          }
          .boken {
            fill: none;
          }
        }
        h3 {
          color: #0055a5;
        }
        p {
          color: #0055a5 !important;
        }
      }
    }
  }
}

.site-bannerbox {
  margin-bottom: 100px;
  h2 {
    color: white;
    font-weight: 700;
    font-size: 38px;
  }
}

@media (max-width: 750px) {
  .about-cards-section {
    .card-container {
      .card-content {
        width: 80% !important;
      }
    }
  }
}

@media (max-width: 950px) {
  .site-bannerbox {
    margin-top: 70px;
    margin-bottom: 70px;
  }
  .about-section {
    flex-direction: column !important;
    padding-bottom: 0;

    .text {
      width: 100%;

      &.right {
        padding-top: 50px;
      }
    }

    .image {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 0;

      div {
        height: 100%;
        background-size: contain;
        background-repeat: no-repeat;
      }
    }

    .image-large {
      margin-top: 60px;
      width: 100%;
    }
  }
}

@media (max-width: 1026px) {
  .about-cards-section {
    .card-container {
      flex-direction: column !important;
      align-items: center !important;

      .card-content {
        width: 50%;
        margin-bottom: 30px;
      }
    }
  }
}
</style>